import axios from 'axios'

export default class Dirigentes {
  constructor(tokenBearer, url) {
    this.url = `${url}/api/dirigente`
    this.urlItens = `${this.url}/itens`
    this.tokenBearer = tokenBearer
  }

  exportar(args) {
    return new Promise(async (resolve, reject) => {
      let optionsDirigentes = {
        method: 'get',
        url: `${this.url}/exportar?${args}`,
        headers: {
          Authorization: this.tokenBearer
        },
        responseType: 'blob'
      }

      try {
        let responseDirigentes = await axios(optionsDirigentes)
        resolve(responseDirigentes)
      } catch (err) {
        reject(err)
      }
    })
  }

  getDirigentes(args) {
    return new Promise(async (resolve, reject) => {
      let optionsDirigentes = {
        method: 'get',
        url: `${this.url}?${args}`,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let responseDirigentes = await axios(optionsDirigentes)
        resolve(responseDirigentes)
      } catch (err) {
        reject(err)
      }
    })
  }

  putMedico(data) {
    return new Promise(async (resolve, reject) => {
      let optionsDirigentes = {
        method: 'put',
        url: `${this.url}/medico`,
        headers: {
          Authorization: this.tokenBearer
        },
        data
      }

      try {
        let responseDirigentes = await axios(optionsDirigentes)
        resolve(responseDirigentes)
      } catch (err) {
        reject(err)
      }
    })
  }

  putNaoMedico(data) {
    return new Promise(async (resolve, reject) => {
      let optionsDirigentes = {
        method: 'put',
        url: `${this.url}/naoMedico`,
        headers: {
          Authorization: this.tokenBearer
        },
        data
      }

      try {
        let responseDirigentes = await axios(optionsDirigentes)
        resolve(responseDirigentes)
      } catch (err) {
        reject(err)
      }
    })
  }

  getDirigenteUnico(id) {
    return new Promise(async (resolve, reject) => {
      let optionsDirigentes = {
        method: 'get',
        url: `${this.url}/${id}`,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let responseDirigentes = await axios(optionsDirigentes)
        resolve(responseDirigentes)
      } catch (err) {
        reject(err)
      }
    })
  }

  getDirigenteItens() {
    return new Promise(async (resolve, reject) => {
      let optionsDirigentes = {
        method: 'get',
        url: this.urlItens,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let responseDirigentes = await axios(optionsDirigentes)
        resolve(responseDirigentes)
      } catch (err) {
        reject(err)
      }
    })
  }

  getPesquisa(input) {
    let valorCampoPesquisa = input

    if (/^\d{3}.?\d{3}.?\d{3}-?\d{2}/.test(valorCampoPesquisa))
      valorCampoPesquisa = valorCampoPesquisa.replace(/[^\d]+/g, '')

    return new Promise(async (resolve, reject) => {
      let optionsDirigentes = {
        method: 'get',
        url: `${this.url}/pesquisa?campoPesquisa=${valorCampoPesquisa}`,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let responseDirigentes = await axios(optionsDirigentes)
        resolve(responseDirigentes)
      } catch (err) {
        reject(err)
      }
    })
  }

  getPesquisaNova(input) {
    let valorCampoPesquisa = input

    if(/^\d{3}.?\d{3}.?\d{3}-?\d{2}/.test(valorCampoPesquisa))
      valorCampoPesquisa = valorCampoPesquisa.replace(/[^\d]+/g, '')
    
    return new Promise(async (resolve, reject) => {
      let optionsDirigentes = {
        method: 'get',
        url: `${this.url}/pesquisaNovos?campoPesquisa=${valorCampoPesquisa}`,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let responseDirigentes = await axios(optionsDirigentes)
        resolve(responseDirigentes)
      } catch (err) {
        reject(err)
      }
    })
  }

  getDirigentesCargo(idDirigente, args = '') {
    return new Promise(async (resolve, reject) => {
      let optionsDirigentes = {
        method: 'get',
        url: `${this.url}/dirigenteCargo/${idDirigente}?${args}`,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let responseDirigentes = await axios(optionsDirigentes)
        resolve(responseDirigentes)
      } catch (err) {
        reject(err)
      }
    })
  }

  getDirigenteInfo(idDirigenteCargo, idMandato, idUnimed) {
    return new Promise(async (resolve, reject) => {
      let optionsDirigente = {
        method: 'get',
        url: `${this.url}/dirigenteCargo/?dirigenteCargoId=${idDirigenteCargo}&mandatoId=${idMandato}&unimedId=${idUnimed}`,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let responseDirigente = await axios(optionsDirigente)
        resolve(responseDirigente)
      } catch (err) {
        reject(err)
      }
    })
  }

  putDirigenteCargo(data) {
    return new Promise(async (resolve, reject) => {
      let optionsDirigente = {
        method: 'put',
        url: `${this.url}/dirigenteCargo`,
        headers: {
          Authorization: this.tokenBearer
        },
        data
      }

      try {
        let responseDirigente = await axios(optionsDirigente)
        resolve(responseDirigente)
      } catch (err) {
        reject(err)
      }
    })
  }
}
